// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__2_tNK","infoBlock":"Login_infoBlock__3D1Vh","FormItem":"Login_FormItem__2ON04","error":"Login_error__n4XNc"};